import { createContext, FC, useContext, useReducer } from "react";

import { ContextType, Filters } from "@interfaces/filters";
import { init, reducer } from "@lib/filters";

const FiltersContext = createContext<ContextType>({} as ContextType);

export const useFilters = (): ContextType => useContext(FiltersContext);

const FiltersContextProvider: FC<Partial<Filters>> = ({
  children,
  ...props
}) => {
  const [filters, dispatch] = useReducer(
    reducer,
    { ...props } as Filters,
    init
  );

  return (
    <FiltersContext.Provider value={{ filters, dispatch }}>
      {children}
    </FiltersContext.Provider>
  );
};

export default FiltersContextProvider;
